import React from 'react';
import { Link } from 'gatsby';
import slugify from 'slugify';
import { capitalize } from 'instantsearch.js/es/lib/utils'
import { Posts } from 'components/Blog'
import { prepareData } from 'utils/googleData'

  export function CategoryPosts(props) {
    const { enable, title, subtitle, text, cta, direction, style, lottie, gatsbyImage, tutorialsCategories } = prepareData({
        props,
    })
    // console.log('tutorialsCategories', JSON.stringify(tutorialsCategories))
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
    return <></>
  }
  return (
      <>
        {tutorialsCategories.group.map(({ category, edges }) => {
          const slug = slugify(category, { lower: true });
          const url = `${cta?.url}/${slug}`;
          return (
            <Posts
              key={category}
              title={capitalize(category)}
              posts={edges}
              action={<Link to={url}>{cta?.label}</Link>}
            />
          );
        })}
      </>
    );
  };
  export default CategoryPosts
